import axios from '../../plugins/axios';
import { utils } from '../../utils/utils';

export default {
  namespaced: true,

  state: () => ({
    businessReviews: [],
    loading: false,
    error: null,
  }),

  mutations: {
    SET_BUSINESS_REVIEWS(state, businessReviews) {
      state.businessReviews = businessReviews;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },

  actions: {
    async getBusinessReviews({ commit }, params) {
      let queryString = '';
      if (params) {
        queryString = utils.formatQueryString(params);
      }

      commit('SET_LOADING', true);
      try {
        const response = await axios.get('/api/v1/business-review' + encodeURI(queryString));
        commit('SET_BUSINESS_REVIEWS', response.data.payload.data);
        return response.data;
      } catch (error) {
        console.error(error);
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async getBusinessReview({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        const response = await axios.get(`/api/v1/business-review/${id}`);
        return response.data;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async getShareLink({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        const response = await axios.get(`/api/v1/business-review/${id}/share-link`);
        return response.data.payload.link;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },

    async createBusinessReview({ commit }, payload) {
      commit('SET_LOADING', true);
      try {
        const response = await axios.post('/api/v1/business-review', payload);
        return response.data;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async deleteBusinessReview({ commit }, id) {
      commit('SET_LOADING', true);
      try {
        const response = await axios.delete(`/api/v1/business-review/${id}`);
        return response.data;
      } catch (error) {
        commit('SET_ERROR', error);
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
};
